import React from "react"

function Checked({ width = 24, height = 24, fill = "none", ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="6 6 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M20.8125 11.4375H11.4375V24.5625H24.5625V20.1875"
        stroke="#003E4C"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.1875 17.6875L18.3125 20.8125L25.8125 12.6875"
        stroke="#003E4C"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
export default Checked
